/* eslint-disable no-console */
/* eslint-disable no-undef */
import { call, put, takeLatest } from 'redux-saga/effects'

import { FAILURE, REQUEST, SUCCESS } from 'Stores'
import {
  changePassword,
  login,
  loginSSOGoogle,
  loginSSOMASL,
  logout,
  postSignUp,
  postSignUpWithInviteRequest,
  postSignUpWithPayment,
  registerEnterprisePlan,
  resendSignUpEmail,
  sendMailResetPassword,
  signUpVerifyToken
} from 'APIs/auth.api'
import { push } from 'connected-react-router'
import { removeLocalStorage, setLocalStorage, STORAGE } from 'Utils'
import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { resetReducer } from 'Modules/userList/dashboard/store/actions'
import { formatMessage } from 'Utils/formatMessage'
import { removeCookie, setCookie } from 'Utils/cookies'
import {
  CHANGE_PASSWORD,
  LOGIN,
  LOGIN_GOOGLE_SSO,
  LOGIN_MS_SSO,
  LOGOUT,
  PAYMENT_REGISTER,
  REGISTER_BASIC,
  REGISTER_BASIC_INVITE,
  REGISTER_ENTERPRISE,
  REGISTER_RESEND_EMAIL,
  RESET_PASSWORD_SEND_MAIL,
  SIGN_UP_VERIFY_TOKEN
} from './constants'
import { clearLocalStorage, LOGIN_MODE } from '../../../Utils/storage'

export function* postBasicSignUp(payload) {
  try {
    const { data } = yield postSignUp(payload.payload)
    if (data.result) {
      yield put({
        type: SUCCESS(REGISTER_BASIC),
        payload: {
          success: true
        }
      })
      switch (payload.payload.signUpMode) {
        case 'free-plan':
          yield put(push('/register/free-plan', { email: payload.payload.email }))
          break
        case 'team-plan':
          yield put(push('/register/team-plan', { ...payload.payload }))
          break
        default:
          yield put(push('/register/free-plan', { email: payload.payload.email }))
          break
      }
    }
  } catch
  (error) {
    yield put(showModalMessage({ message: error.message }))
    yield put({
      type: FAILURE(REGISTER_BASIC),
      error
    })
  }
}

export function* postPaymentSignUp(payload) {
  try {
    const res = yield postSignUpWithPayment(payload.payload)
    if (res) {
      yield put({
        type: SUCCESS(PAYMENT_REGISTER),
        payload: {
          success: true
        }
      })
      yield put(push('/register/team-plan/verified'))
    }
  } catch
  (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(PAYMENT_REGISTER),
      error
    })
  }
}

export function* postSignUpWithInvite(payload) {
  try {
    const res = yield postSignUpWithInviteRequest(payload.payload)
    if (res) {
      yield put({
        type: SUCCESS(REGISTER_BASIC_INVITE),
        payload: {
          success: true
        }
      })
      yield put(push('/register/verified'))
    }
  } catch
  (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(REGISTER_BASIC_INVITE),
      error
    })
  }
}

export function* postReSendSignUpEmail(payload) {
  try {
    yield resendSignUpEmail(payload.payload)
    yield put({
      type: SUCCESS(REGISTER_RESEND_EMAIL)
    })
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(REGISTER_RESEND_EMAIL),
      error
    })
  }
}

export function* loadLogin({ payload }) {
  try {
    const { remember } = payload
    const data = yield call(login, payload)
    if (!remember) {
      setCookie(STORAGE.USER_EMAIL, data.result.user.email, 0)
      setCookie(STORAGE.USER_TOKEN, data.result.token, 0)
      setCookie(STORAGE.ROLE, data.result.user.role, 0)
    } else {
      setLocalStorage(STORAGE.USER_EMAIL, data.result.user.email)
      setLocalStorage(STORAGE.USER_TOKEN, data.result.token)
      setLocalStorage(STORAGE.ROLE, data.result.user.role)
    }

    setLocalStorage(STORAGE.USER_LOGIN, 'USER_LOGIN')
    setLocalStorage(STORAGE.NOT_AUTHENTICATED_ERROR, '')
    setLocalStorage(STORAGE.EMAIL_CHANGE_VERIFY, '')
    yield put({
      type: SUCCESS(LOGIN),
      payload: data.result.user,
      isCheck2FA: false
    })
    yield put(push('/dashboard'))
  } catch (error) {
    yield put(showModalMessage({ message: formatMessage(error) }))
    yield put({
      type: FAILURE(LOGIN),
      error
    })
  }
}

export function* loadLoginGoogleSSO({ payload }) {
  try {
    const data = yield call(loginSSOGoogle, payload)
    setLocalStorage(LOGIN_MODE.LABEL, LOGIN_MODE.GOOGLE)
    setLocalStorage(STORAGE.USER_TOKEN, data.result.token)
    setLocalStorage(STORAGE.EMAIL_CHANGE_VERIFY, '')
    yield put({
      type: SUCCESS(LOGIN_GOOGLE_SSO)
    })
    yield put(push('/dashboard'))
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(LOGIN_GOOGLE_SSO),
      error
    })
  }
}

export function* loadLoginMSSSO({ payload }) {
  try {
    const data = yield call(loginSSOMASL, payload)
    removeLocalStorage(STORAGE.USER_TOKEN)
    setLocalStorage(LOGIN_MODE.LABEL, LOGIN_MODE.MS)
    setLocalStorage(STORAGE.USER_TOKEN, data.result.token)
    setLocalStorage(STORAGE.EMAIL_CHANGE_VERIFY, '')
    yield put({
      type: SUCCESS(LOGIN_MS_SSO)
    })
    yield put(push('/dashboard'))
  } catch (error) {
    removeLocalStorage(STORAGE.USER_TOKEN)
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(LOGIN_MS_SSO),
      error
    })
  }
}

export function* resetPasswordSendMail({ payload }) {
  try {
    yield put(showOverlay())
    const { email } = payload
    yield call(sendMailResetPassword, { email })
    yield put(push(`/send-mail/${email}`))
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export function* handleChangePassword({ payload }) {
  try {
    yield put(showOverlay())
    yield call(changePassword, payload)
    yield put(hideOverlay())
    yield put(push('/reset-success'))
  } catch (error) {
    yield put(hideOverlay())
    if (error === 'TOKEN_EXPIRE_OR_INVALID') {
      yield put(showModalMessage({ message: formatMessage('RESET_TOKEN_EXPIRE_OR_INVALID') }))
    } else {
      yield put(showModalMessage({ message: formatMessage(error) }))
    }
    yield put(push('/not-found'))
  }
}

export function* registerEnterprise({ payload }) {
  try {
    yield call(registerEnterprisePlan, payload)
    yield put({
      type: SUCCESS(REGISTER_ENTERPRISE)
    })
    yield put(push('/register/enterprise-plan/contact/success', payload.contactInfo))
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(REGISTER_ENTERPRISE)
    })
  }
}

export function* signUpTokenVerify({ payload }) {
  try {
    yield call(signUpVerifyToken, payload)
    yield put(showModalMessage({ message: 'Email Verified', type: 'success' }))
  } catch (error) {
    yield put(showModalMessage({ message: error }))
  }
}

export function* logoutSaga({ payload }) {
  try {
    if (!payload) yield call(logout)
    clearLocalStorage()
    removeCookie(STORAGE.USER_EMAIL)
    removeCookie(STORAGE.USER_TOKEN)
    removeCookie(STORAGE.ROLE)
    yield put(resetReducer())
    // eslint-disable-next-line no-empty
  } catch (err) {
    console.log(err)
  }
}

export default function* authSaga() {
  yield takeLatest(REQUEST(REGISTER_BASIC), postBasicSignUp)
  yield takeLatest(REQUEST(REGISTER_BASIC_INVITE), postSignUpWithInvite)
  yield takeLatest(REQUEST(PAYMENT_REGISTER), postPaymentSignUp)
  yield takeLatest(REQUEST(REGISTER_RESEND_EMAIL), postReSendSignUpEmail)
  yield takeLatest(REQUEST(LOGIN), loadLogin)
  yield takeLatest(REQUEST(LOGIN_GOOGLE_SSO), loadLoginGoogleSSO)
  yield takeLatest(REQUEST(LOGIN_MS_SSO), loadLoginMSSSO)
  yield takeLatest(REQUEST(RESET_PASSWORD_SEND_MAIL), resetPasswordSendMail)
  yield takeLatest(REQUEST(CHANGE_PASSWORD), handleChangePassword)
  yield takeLatest(REQUEST(REGISTER_ENTERPRISE), registerEnterprise)
  yield takeLatest(REQUEST(SIGN_UP_VERIFY_TOKEN), signUpTokenVerify)
  yield takeLatest(REQUEST(LOGOUT), logoutSaga)
}
